import React, { Component } from 'react';
import App_data from '../../../config/App_data';
import FD from '../../../RestAPI/fetchData';
import cjquery from 'jquery';
// import StarRatingComponent from 'react-star-rating-component';
import StarRatings from 'react-star-ratings';
import language from '../../../../assets/languages/language';
import { Tooltip, Col, Row } from 'reactstrap';
import SoaFM_SubscriptionCheck from '../../../RestAPI/SoaFMSubscription';
import PartnerSoaFM_SubscriptionCheck from '../../../RestAPI/PartnerSubscription/SoaFMSubscription';
// import { getDeviceDetails } from "../../../../common/deviceDetails";
// import GD from '../../../RestAPI/getData';
import { getIpAddress } from '../../../../common/getIpAddress';
import ValidateSaveReportIcon from '../../../Common/ValidateSaveReportIcon';
import FlashCard from '../../../../components/FlashCard';
import { isRevisionModeActive, renderHTMLContent } from '../../../../common/function';
import ViewQuestion from '../../../../Components-2025/QuestionBank/ViewQuestion';
import { EXAM_NAMES } from '../../../../common/constant';
/* eslint-disable*/
class SOA_FM_Beginchapters extends Component {
  constructor(props) {
    super(props);

    this.state = {
      alert_status: false,
      successAlert: false,
      MessageTitle: `${language.LC().ALERT}`,
      MessageContent: `${language.LC().ERROR}`,
      questions: [],
      all_questions_state: [],
      token: '',
      idname: '',
      reportLoading: false,
      ValidToken: false,
      chapter_id: '',
      offset: 0,
      limit: 1,
      choice_a: 'answer_box',
      choice_b: 'answer_box',
      choice_c: 'answer_box',
      choice_d: 'answer_box',
      choice_e: 'answer_box',
      result_block: 'card hide_block',
      report_block: 'card hide_block',
      clicked: false,
      choice: '',
      result: '',
      text_color: 'card-header',
      records: '',
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      bookmarkColor: '',
      flagCSS: 'fa fa-flag-o mark-action-btn',
      timerstopbtn: 'icon-control-pause pause_btn',
      save_text: `${language.LC().SAVE_QUESTION}`,
      savedQuestion: false,
      comment: 'card-block',
      flashcard: 'card-block',
      comment_data: '',
      flash_data: [],
      // flash_form : 'col-sm-12 col-md-12 display_block',
      comment_arrow: '',
      flash_card_arrow: '',
      flash_class: 'edit_right_padding',
      count: 0,
      rating: 0,
      rated: false,
      ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
      validated: false,
      comment_update: 'hide_block',
      comment_save: 'btn btn-primary active pointer_class margin_bottom_20',
      comment_update_id: '',
      next_block: '',
      previ_block: '',
      question_length: '',
      timer_stop: false,
      timer_tag: `${language.LC().STOP}`,
      display_loader: '',
      selectedmenu: 'soa_fm',
      subscriptionstatus: 'free',
      chapter_name: '',
      isEditable: false,
      all_questions: '',
      category: 'Actuarial - FM(Financial Mathematics)',
      tags: ['Financial Mathematics', 'acturial', 'exam', 'question'],
      title: '',
      description: '',
      page: this.props.params.page,
      forumComment: '',
      isFlashCardHidden: true,
      tooltips: [
        {
          placement: `${language.LC().COMMENT_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
        {
          placement: `${language.LC().REPORT_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
        {
          placement: `${language.LC().FLASHCARD_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
      ],
      user_city: '',
      user_country: '',
      user_ip: '',
      user_state: '',
      user_continent: '',
      selectedChoice: '',
      setAnswer: false,
      showAnswer: false,
      stopTimer: false,
      attemptedQuestions: {},
    };
    this.childRef = null;
    this.setChildRef = (element) => {
      this.childRef = element;
    };
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  saveForumComment(e) {
    this.setState({ forumComment: e.target.value });
  }

  /*
  -----------------------------------------
    Function to change, time every second
  ----------------------------------------
  */
  _tick() {
    const { timer_stop } = this.state;
    if (!timer_stop) {
      this.setState((prevState) => ({
        count: prevState.count + 1,
      }));
    }
  }

  /*
  -----------------------------------------------
    Function to redirect page to readings page
  -----------------------------------------------
  */
  _getReadings = () => {
    this.context.router.push({
      pathname: `/soa/financialmathematics/readings/${this.props.params.notesid}/${
        this.state.page
      }`,
      state: {
        token: this.state.token,
        idname: this.state.idname,
        chapter: this.props.params.notesid,
      },
    });
  };

  /*
  ---------------------------------------
    Function to toggle Comment box
  ---------------------------------------
  */
  _getToggleComment = (item, e) => {
    cjquery(this.refs['comment_toggle_div']).slideToggle(1000);
  };

  /*
  ------------------------------------
    Function to toggle Flash box
  ------------------------------------  
  */
  _getToggleFlash = (item, e) => {
    cjquery(this.refs['flash_toggle_div']).slideToggle(1000);
  };

  /*
  ------------------------------------------
    Function to fetch previous question
  ------------------------------------------
  */
  getPrevious = () => {
    this.setState({ display_loader: 'show_block' });
    const { offset, question_length, all_questions_state, attemptedQuestions, token, idname } =
      this.state;
    const prevIndex = offset - 1;
    this.setState({
      offset: prevIndex,
      questions: all_questions_state[prevIndex],
    });
    if (prevIndex < parseInt(question_length) - 1) {
      this.setState({ next_block: '' });
    }
    if (prevIndex === 0) {
      this.setState({ previ_block: 'card hide_block' });
    }
    const { params } = this.props;
    const prevQuestionId = all_questions_state[prevIndex].id;
    // Update the URL when navigating to the previous question
    this.context.router.push({
      pathname: `/soa/financialmathematics/beginchapter/${this.state.page}/${params.notesid}/${prevQuestionId}/${prevIndex}`,
      state: {
        token,
        idname,
        chapter: params.notesid,
        offset: prevIndex,
      },
    });
    // Check if the previous question is saved
    const favParams = {
      token,
      question_id: prevQuestionId,
      idname,
    };
    FD.callAPI(`${App_data.backend_api}/soa_fm_question_bank/getFavQuestions`, favParams).then(
      (response) => {
        const isSaved = response.success;

        this.setState({
          save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
          bookmarkCSS: isSaved
            ? 'fa fa-bookmark mark-action-btn-bookmark'
            : 'fa fa-bookmark-o mark-action-btn-bookmark',
          bookmarkColor: isSaved ? 'rgb(54, 141, 84)' : '',
          save_text: isSaved ? language.LC().Question_Saved : language.LC().SAVE_QUESTION,
          isFlashCardHidden: !isSaved,
        });
      },
    );
    this.setState({ questions: all_questions_state[prevIndex] }, () => {
      this.setState({ rating: 0, ratting_text: 'Rate this Question', rated: false });
      const ratingParams = {
        token,
        question_id: this.state.questions.id,
        idname,
      };
      FD.callAPI(`${App_data.backend_api}/soa_fm_question_bank/getRatting`, ratingParams).then(
        (response) => {
          if (response.success && response.ratting.length > 0) {
            this.setState({
              rating: response.ratting[0].ratting,
              ratting_text: `${language.LC().RATED}`,
              rated: true,
            });
          } else {
            this.setState({ rating: 0, ratting_text: 'Rate this Question', rated: false });
          }
        },
      );
    });
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    let selected = '';
    let showAnswer = false;
    const currentQuestion = all_questions_state[prevIndex];
    const currentAttempts = attemptedQuestions || {};
    const previousAttempt = currentAttempts[currentQuestion.id] || {};
    const selectedChoice =
      previousAttempt.selectedChoice ||
      currentQuestion['soa_fm_question_stats.selected_choice'] ||
      '';
    const rightAnswer = currentQuestion['soa_fm_question_stats.right_answer'];
    const answerStatus = currentQuestion['soa_fm_question_stats.id'] || '';
    const timeDone = currentQuestion['soa_fm_question_stats.time_done'] || '';
    const correctChoiceKey = 'right_choice';
    if (selectedChoice && isRevisionModeActive(EXAM_NAMES.SOA_FM)) {
      selected = selectedChoice;
      showAnswer = true;
    } else if (answerStatus && isRevisionModeActive(EXAM_NAMES.SOA_FM)) {
      if (rightAnswer === 1) {
        selected = currentQuestion[correctChoiceKey];
        showAnswer = true;
      } else if (!rightAnswer) {
        const choices = Object.keys(currentQuestion).filter(
          (key) => key.startsWith('choice') && key !== correctChoiceKey,
        );
        selected = choices.length > 0 ? choices[0] : '';
        showAnswer = true;
      }
    }
    const isCorrect = selected === currentQuestion[correctChoiceKey];
    if (selected && isRevisionModeActive(EXAM_NAMES.SOA_FM)) {
      clearInterval(this.timer);
      this.setState({
        timer_stop: true,
        timer_tag: 'Start',
        timerstopbtn: 'pause_btn icon-control-play',
        count: timeDone || this.state.count,
        selectedChoice: selected,
        clicked: true,
        showAnswer,
        stopTimer: true,
        setAnswer: true,
        ...this.getChoices(selected, isCorrect, correctChoiceKey),
        result_block: 'card show_block',
        text_color: isCorrect ? 'card-header text_success' : 'card-header text_failure',
        result: isCorrect ? 'CORRECT' : 'INCORRECT',
        timerstopbtn: 'pause_btn icon-control-play',
        report_block: 'card hide_block',
        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
        save_text: `${language.LC().SAVE_QUESTION}`,
        rated: false,
        rating: 0,
        ratting_text: 'Rate this Question',
        previ_block: prevIndex === 0 ? 'hide_block' : '',
        next_block: parseInt(question_length) - 1 === prevIndex ? 'hide_block' : '',
      });
    } else {
      clearInterval(this.timer);
      this.setState({
        timer_stop: false,
        timer_tag: 'Stop',
        timerstopbtn: 'pause_btn icon-control-pause',
        count: 0,
        selectedChoice: '',
        clicked: false,
        showAnswer: false,
        stopTimer: false,
        setAnswer: false,
        result_block: 'card hide_block',
        ...this.getChoices('', false, ''),
        previ_block: prevIndex === 0 ? 'hide_block' : '',
        next_block: parseInt(question_length) - 1 === prevIndex ? 'hide_block' : '',
      });
      this.timer = setInterval(this._tick.bind(this), 1000);
    }
    this.setState({ display_loader: 'hide_block' });
  };

  /*
  ------------------------------------
    Function to fetch Next question
  ------------------------------------
    */
  getNext = () => {
    this.setState({ display_loader: 'show_block' });
    const {
      offset,
      question_length,
      all_questions_state,
      attemptedQuestions,
      token,
      idname,
      page,
    } = this.state;
    const nextIndex = offset + 1;
    this.setState({
      offset: nextIndex,
      questions: all_questions_state[nextIndex],
    });
    if (parseInt(question_length) - 1 === nextIndex) {
      this.setState({ next_block: 'card hide_block' });
    }
    if (nextIndex !== 0) {
      this.setState({ previ_block: '' });
    }
    const nextQuestionId = all_questions_state[nextIndex].id;
    const { params } = this.props;
    this.context.router.push({
      pathname: `/soa/financialmathematics/beginchapter/${page}/${params.notesid}/${nextQuestionId}/${nextIndex}`,
      state: {
        token,
        idname,
        chapter: params.notesid,
        offset: nextIndex,
      },
    });
    // Check if the next question is saved
    const favParams = {
      token,
      question_id: nextQuestionId,
      idname,
    };
    FD.callAPI(`${App_data.backend_api}/soa_fm_question_bank/getFavQuestions`, favParams).then(
      (response) => {
        const isSaved = response.success;

        this.setState({
          save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
          bookmarkCSS: isSaved
            ? 'fa fa-bookmark mark-action-btn-bookmark'
            : 'fa fa-bookmark-o mark-action-btn-bookmark',
          bookmarkColor: isSaved ? 'rgb(54, 141, 84)' : '',
          save_text: isSaved ? language.LC().Question_Saved : language.LC().SAVE_QUESTION,
          isFlashCardHidden: !isSaved,
        });
      },
    );

    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    let selected = '';
    let showAnswer = false;
    const currentQuestion = all_questions_state[nextIndex];
    const currentAttempts = attemptedQuestions || {};
    const previousAttempt = currentAttempts[currentQuestion.id] || {};
    const selectedChoice =
      previousAttempt.selectedChoice ||
      currentQuestion['soa_fm_question_stats.selected_choice'] ||
      '';
    const rightAnswer = currentQuestion['soa_fm_question_stats.right_answer'];
    const answerStatus = currentQuestion['soa_fm_question_stats.id'] || '';
    const timeDone = currentQuestion['soa_fm_question_stats.time_done'] || '';
    const correctChoiceKey = 'right_choice';
    if (selectedChoice && isRevisionModeActive(EXAM_NAMES.SOA_FM)) {
      selected = selectedChoice;
      showAnswer = true;
    } else if (answerStatus && isRevisionModeActive(EXAM_NAMES.SOA_FM)) {
      if (rightAnswer === 1) {
        selected = currentQuestion[correctChoiceKey];
        showAnswer = true;
      } else if (!rightAnswer) {
        const choices = Object.keys(currentQuestion).filter(
          (key) => key.startsWith('choice') && key !== correctChoiceKey,
        );
        selected = choices.length > 0 ? choices[0] : '';
        showAnswer = true;
      }
    }
    const isCorrect = selected === currentQuestion[correctChoiceKey];
    if (selected && isRevisionModeActive(EXAM_NAMES.SOA_FM)) {
      clearInterval(this.timer);
      this.setState({
        timer_stop: true,
        timer_tag: 'Start',
        timerstopbtn: 'pause_btn icon-control-play',
        count: timeDone || this.state.count,
        selectedChoice: selected,
        clicked: true,
        showAnswer,
        stopTimer: true,
        setAnswer: true,
        ...this.getChoices(selected, isCorrect, correctChoiceKey),
        result_block: 'card show_block',
        text_color: isCorrect ? 'card-header text_success' : 'card-header text_failure',
        result: isCorrect ? 'CORRECT' : 'INCORRECT',
      });
    } else {
      clearInterval(this.timer);
      this.setState({
        timer_stop: false,
        timer_tag: 'Stop',
        timerstopbtn: 'pause_btn icon-control-pause',
        count: 0,
        selectedChoice: '',
        clicked: false,
        showAnswer: false,
        stopTimer: false,
        setAnswer: false,
        result_block: 'card hide_block',
        ...this.getChoices('', false, ''),
        next_block: parseInt(question_length) - 1 === nextIndex ? 'hide_block' : '',
      });
      this.timer = setInterval(this._tick.bind(this), 1000);
    }
    this.setState({ display_loader: 'hide_block' });
    this.setState({ rating: 0, ratting_text: 'Rate this Question', rated: false });
    const ratingParams = {
      token,
      question_id: currentQuestion.id,
      idname,
    };
    FD.callAPI(`${App_data.backend_api}/soa_fm_question_bank/getRatting`, ratingParams).then(
      (response) => {
        if (response.success && response.ratting.length > 0) {
          this.setState({
            rating: response.ratting[0].ratting,
            ratting_text: `${language.LC().RATED}`,
            rated: true,
          });
        } else {
          this.setState({ rating: 0, ratting_text: 'Rate this Question', rated: false });
        }
      },
    );
  };

  /*
  ------------------------------------------------------------------------
    Function to check Right Or Wrong Answered and displayed clicked box
  ------------------------------------------------------------------------
  */
  getAnswer = (choice, e) => {
    const {
      questions,
      user_city,
      user_country,
      user_state,
      user_continent,
      user_ip,
      token,
      idname,
      attemptedQuestions,
      props,
    } = this.state;
    const currentQuestionId = questions.id;
    const selectedChoice = choice[0];
    this.setState(
      {
        selectedChoice,
        setAnswer: true,
        clicked: false,
        showAnswer: false,
        stopTimer: false,
        ...this.getChoices(selectedChoice, false, ''),
      },
      () => {
        const currentAttempts = attemptedQuestions || {};
        const updatedAttempts = {
          ...currentAttempts,
          [currentQuestionId]: {
            selectedChoice: this.state.selectedChoice,
            isAnswered: false,
            setAnswer: true,
          },
        };
        this.setState({ attemptedQuestions: updatedAttempts });
      },
    );
    const data = {
      token,
      idname,
      id: props.params.id,
      city: user_city,
      country: user_country,
      state: user_state,
      continent: user_continent,
      ip: user_ip,
    };
    FD.callAPI(`${App_data.backend_api}/soa_fm_question_bank/trackUserRecord`, data).then(
      (resp) => {
        if (resp.success) {
          this.setState({ ValidToken: true });
        }
      },
    );
  };

  _displayReportForm = (item, e) => {
    this.setState({ report_block: 'card show_block' });
  };

  /*
  --------------------------------
    Function to hide Report box
  --------------------------------
    */
  _hideReportForm = (item, e) => {
    this.setState({ report_block: 'card hide_block' });
  };

  /*
  -------------------------------------------------------------------------------
    Function to show Correct box and display right answer and store in database
  -------------------------------------------------------------------------------
  */
  getResult = (item, e) => {
    const {
      selectedChoice,
      timer,
      count,
      attemptedQuestions,
      ValidToken,
      validated,
      token,
      idname,
    } = this.state;
    if (selectedChoice) {
      if (timer) {
        clearInterval(timer);
        this.timer = null;
      }
      const currentQuestionId = item.id;
      const correctChoiceKey = 'right_choice';
      const isCorrect = selectedChoice === `${item[correctChoiceKey]}`;
      this.setState(
        {
          timer_stop: true,
          timer_tag: 'Start',
          timerstopbtn: 'pause_btn icon-control-play',
          setAnswer: true,
          clicked: true,
          showAnswer: true,
          stopTimer: true,
          result_block: 'card show_block',
          result: isCorrect ? 'CORRECT' : 'INCORRECT',
          text_color: isCorrect ? 'card-header text_success' : 'card-header text_failure',
        },
        () => {
          const currentAttempts = attemptedQuestions || {};
          const updatedAttempts = {
            ...currentAttempts,
            [currentQuestionId]: {
              selectedChoice,
              isAnswered: true,
              isCorrect,
              setAnswer: true,
              timeSpent: count,
            },
          };
          this.setState({ attemptedQuestions: updatedAttempts });
          if (isCorrect) {
            this.setState({ ...this.getChoices(selectedChoice, isCorrect, correctChoiceKey) });
          } else {
            this.setState({ ...this.getChoices(item.right_choice, isCorrect, correctChoiceKey) });
          }
        },
      );
      if (!validated) {
        const data = {
          token,
          idname,
          question_id: item.id,
          right_answer: isCorrect ? 1 : 0,
          time_done: count,
          selected_choice: selectedChoice,
        };
        FD.callAPI(`${App_data.backend_api}/soa_fm_question_bank/saveStats`, data).then((resp) => {
          if (resp.success) {
            this.setState({ ValidToken: true, validated: true });
          } else {
            this.setState({ ValidToken: false });
          }
          return resp;
        });
      }
    } else {
      this.setState({
        result_block: 'card hide_block',
      });
    }
  };

  /*
  ----------------------------------------------------------------------
    Function to Display Saved Question on button and save in database
  ----------------------------------------------------------------------
    */
  _saveQuestion = (item, e) => {
    const { bookmarkCSS, bookmarkColor, save_text, save_question, isFlashCardHidden } = this.state;
    const { token, idname } = this.state;
    const data = {
      token,
      idname,
      question_id: item.id,
    };
    if (bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
      FD.callAPI(`${App_data.backend_api}/soa_fm_question_bank/unsaveQuestion`, data).then(
        (resp) => {
          if (resp.success) {
            if (this.childRef) {
              this.childRef.deleteFlash();
            }
            this.setState({
              ValidToken: true,
              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
              bookmarkColor: '',
              save_text: `${language.LC().SAVE_QUESTION}`,
              isFlashCardHidden: true,
            });
          } else {
            this.setState({ ValidToken: false });
          }
          return resp;
        },
      );
    } else {
      FD.callAPI(`${App_data.backend_api}/soa_fm_question_bank/saveQuestion`, data).then((resp) => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
            bookmarkColor: 'rgb(54, 141, 84)',
            save_text: `${language.LC().Question_Saved}`,
            isFlashCardHidden: false,
          });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      });
    }
  };
  /*
  ------------------------------------------------------------------
    Function to Save flash Card And display new stored flash card
  ------------------------------------------------------------------
    */
  _saveFlashCard = (item, e) => {
    if (document.getElementById('flash_card').value == '') {
      return;
    }

    const flash_card = document.getElementById('flash_card').value;
    const data = {
      token,
      idname,
      question_id: item.id,
      flash_card,
    };
    FD.callAPI(`${App_data.backend_api}/soa_fm_question_bank/saveFlashCard`, data).then((resp) => {
      if (resp.success) {
        this.setState({ ValidToken: true });
        document.getElementById('flash_card').value = '';
        const params = {
          token,
          idname,
          question_id: item.id,
        };
        FD.callAPI(`${App_data.backend_api}/soa_fm_question_bank/getFlashCards`, params).then(
          (response) => {
            if (response.success) {
              this.setState({ ValidToken: true });
              if (response.flash_cards.length > 0) {
                this.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
                const flashCards = response.flash_cards.map((items, index) => (
                  <li key={index}>
                    <div className=''>
                      <ul className='icon_list'>
                        <li>
                          <a className='pointer_class' onClick={this._editFlash.bind(this, items)}>
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteFlash.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                      <div className={this.state.flash_class}>
                        <h4 />
                        <p>{items.flash_card}</p>
                      </div>
                    </div>
                  </li>
                ));
                this.setState({ flash_data: flashCards });
              } else {
                this.setState({
                  flash_form: 'col-sm-12 col-md-12 display_block',
                });
                const flashCards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
                this.setState({ flash_data: flashCards });
              }
            } else {
              const flashCards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
              this.setState({
                ValidToken: false,
                flash_data: flashCards,
                flash_form: 'col-sm-12 col-md-12 display_block',
              });
            }
            return response;
          },
        );
      } else {
        this.setState({ ValidToken: false });
      }
    });
  };

  /*
  -----------------------------------------
    Funcion to save new report question
  -----------------------------------------
  */
  _reportQuestion = (item, e) => {
    const { reportLoading } = this.state;
    const comment = document.getElementById('comment').value;
    if (comment.length < 2) {
      return;
    }
    const data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
      comment,
      city: this.state.user_city,
      country: this.state.user_country,
      state: this.state.user_state,
      continent: this.state.user_continent,
      ip: this.state.user_ip,
    };
    this.setState({
      reportLoading: true,
    });
    FD.callAPI(`${App_data.backend_api}/soa_fm_question_bank/reportQuestion`, data).then((resp) => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          successAlert: true,
          reportLoading: false,
        });
        document.getElementById('comment').value = '';
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  };

  onClose = (e) => {
    this.setState({
      report_block: 'card hide_block',
      successAlert: false,
    });
  };
  /*
  -------------------------------
    Function to Edit Flash card
  -------------------------------
    */
  _editFlash = (item, e) => {
    this.setState({
      flash_form: 'col-sm-12 col-md-12 display_block',
      isEditable: true,
    });

    document.getElementById('flash_card').value = item.flash_card;
  };

  /*
  -----------------------------------
    Function to delete flash card
  -----------------------------------
    */
  _deleteFlash = (item, e) => {
    const { token, idname } = this.state;
    const data = {
      token,
      idname,
      flash_card: item,
    };
    FD.callAPI(`${App_data.backend_api}/soa_fm_question_bank/deleteFlashCard`, data).then(
      (resp) => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            flash_form: 'col-sm-12 col-md-12 display_block',
            isEditable: false,
          });
          document.getElementById('flash_card').value = '';
          const flashCards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
          this.setState({ flash_data: flashCards });
        } else {
          this.setState({ ValidToken: false });
        }
      },
    );
  };

  /*
  ---------------------------------
    Function to give star rattings
  ---------------------------------
  */
  onStarClick = (item, nextValue, prevValue, name) => {
    const { token, idname } = this.state;
    this.setState({ rating: nextValue, ratting_text: `${language.LC().RATED}`, rated: true });
    const params = {
      token,
      idname,
      question_id: item.id,
      ratting: nextValue,
    };
    FD.callAPI(`${App_data.backend_api}/soa_fm_question_bank/saveRatting`, params).then(
      (response) => {
        if (response.success) {
          const getParams = {
            token,
            question_id: item.id,
            idname,
          };
          FD.callAPI(`${App_data.backend_api}/soa_fm_question_bank/getRatting`, getParams).then(
            (resp) => {
              if (resp.success && resp.ratting.length > 0) {
                this.setState({
                  rating: resp.ratting[0].ratting,
                  ratting_text: `${language.LC().RATED}`,
                  rated: true,
                });
              } else {
                this.setState({ rating: 0, ratting_text: 'Rate this Question', rated: false });
              }
            },
          );
        } else {
          FD.callAPI(
            `${App_data.backend_api}/soa_fm_question_bank/UpdateSoaFmRatting`,
            params,
          ).then(() => {
            const getParams = {
              token,
              question_id: item.id,
              idname,
            };
            FD.callAPI(`${App_data.backend_api}/soa_fm_question_bank/getRatting`, getParams).then(
              (resp) => {
                if (resp.success && resp.ratting.length > 0) {
                  this.setState({
                    rating: resp.ratting[0].ratting,
                    ratting_text: `${language.LC().RATED}`,
                    rated: true,
                  });
                } else {
                  this.setState({ rating: 0, ratting_text: 'Rate this Question', rated: false });
                }
              },
            );
          });
        }
      },
    );
  };

  _getSubscribe = () => {
    this.context.router.push({
      pathname: '/subscribe/',
      state: { token: this.state.token, idname: this.state.idname },
    });
  };

  async componentDidMount() {
    window.scrollTo(0, 0);

    // Clear any existing timer first
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }

    // Initialize timer state
    this.setState({
      count: 0,
      timer_stop: true,
      timer_tag: 'Start',
      timerstopbtn: 'pause_btn icon-control-play',
    });

    // api to get ip address
    const result = await getIpAddress();
    if (result) {
      this.setState({
        user_city: result.city,
        user_country: result.country,
        user_ip: result.query,
        user_state: result.region,
        user_continent: result.continent,
      });
    }

    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (storage_session) {
      this.setState({
        idname: storage_session['idname'],
        token: storage_session['token'],
      });
    }

    var user_data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
    };

    FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then((resp) => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this._runCode('free');
          this.setState({ subscriptionstatus: 'free' });
        } else {
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            (resp_exam) => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = PartnerSoaFM_SubscriptionCheck.checkSoaFMSubscription(
                  selectedmen,
                  exam_data,
                );
                if (isInArray_var) {
                  this._runCode('paid');
                  this.setState({ subscriptionstatus: 'paid' });
                } else {
                  this._runCode('free');
                  this.setState({ subscriptionstatus: 'free' });
                }
              }
            },
          );
        }
      } else {
        if (resp.profileInfo.exam_selected === '') {
          this._runCode('free');
          this.setState({ subscriptionstatus: 'free' });
        } else {
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            (resp_exam) => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = SoaFM_SubscriptionCheck.checkSoaFMSubscription(
                  selectedmen,
                  exam_data,
                );
                if (isInArray_var) {
                  this._runCode('paid');
                  this.setState({ subscriptionstatus: 'paid' });
                } else {
                  this._runCode('free');
                  this.setState({ subscriptionstatus: 'free' });
                }
              }
            },
          );
        }
      }
    });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (this.props.params.page !== prevProps.params.page) {
      var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
      this.setState({
        idname: storage_session['idname'],
        token: storage_session['token'],
      });
      var user_data = {
        idname: storage_session['idname'],
        token: storage_session['token'],
      };
      FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then((resp) => {
        if (resp.profileInfo.role === 'partner') {
          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
            this._runCode('free');
            this.setState({ subscriptionstatus: 'free' });
          } else {
            var data_arr = resp.profileInfo.exam_selected
              ? JSON.parse(resp.profileInfo.exam_selected)
              : null;

            var dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
              async (resp_exam) => {
                if (resp_exam.success) {
                  var exam_data = resp_exam.examData;
                  var selectedmen = this.state.selectedmenu;
                  var isInArray_var = false;
                  isInArray_var = await PartnerSoaFM_SubscriptionCheck.checkSoaFMSubscription(
                    selectedmen,
                    exam_data,
                  );
                  if (isInArray_var) {
                    this._runCode('paid');
                    this.setState({ subscriptionstatus: 'paid' });
                  } else {
                    this._runCode('free');
                    this.setState({ subscriptionstatus: 'free' });
                  }
                }
              },
            );
          }
        } else {
          if (resp.profileInfo.exam_selected === '') {
            this._runCode('free');
            this.setState({ subscriptionstatus: 'free' });
          } else {
            var data_arr = resp.profileInfo.exam_selected
              ? JSON.parse(resp.profileInfo.exam_selected)
              : null;
            var dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
              (resp_exam) => {
                if (resp_exam.success) {
                  var exam_data = resp_exam.examData;
                  var selectedmen = this.state.selectedmenu;
                  var isInArray_var = false;
                  isInArray_var = SoaFM_SubscriptionCheck.checkSoaFMSubscription(
                    selectedmen,
                    exam_data,
                  );
                  if (isInArray_var) {
                    this._runCode('paid');
                    this.setState({ subscriptionstatus: 'paid' });
                  } else {
                    this._runCode('free');
                    this.setState({ subscriptionstatus: 'free' });
                  }
                }
              },
            );
          }
        }
      });
    }
  }
  async _runCode(subscriptionStatus) {
    this.setState({ display_loader: 'show_block' });
    // Clear any existing timer
    clearInterval(this.timer);

    const storageSession = JSON.parse(localStorage.getItem('localstorageval'));
    const { page, offset } = this.state;
    const { notesid, id } = this.props.params;
    const data = {
      idname: storageSession['idname'],
      token: storageSession['token'],
      reading_id: page,
      chapter_id: notesid,
      offset,
      subscriptionstatus: subscriptionStatus,
    };

    await FD.callAPI(`${App_data.backend_api}/soa_fm_question_bank/getQuestions_allcr`, data).then(
      (resp) => {
        if (resp.success && resp.questions && resp.questions.length > 0) {
          this.setState({
            ValidToken: true,
            alert_status: false,
            MessageTitle: '',
            MessageContent: '',
            all_questions_state: resp.questions,
          });
          let quesRes = [];
          let offsetRes = '';
          for (let i = 0; i < resp.questions.length; i++) {
            if (resp.questions[i].id == id) {
              quesRes = resp.questions[i];
              offsetRes = i;
              const currentQuestion = resp.questions[i];
              let selected = '';
              let showAnswer = false;
              const selectedChoice = currentQuestion['soa_fm_question_stats.selected_choice'] || '';
              const rightAnswer = currentQuestion['soa_fm_question_stats.right_answer'];
              const answerStatus = currentQuestion['soa_fm_question_stats.id'] || '';
              const timeDone = currentQuestion['soa_fm_question_stats.time_done'] || '';
              const correctChoiceKey = 'right_choice';
              if (selectedChoice && isRevisionModeActive(EXAM_NAMES.SOA_FM)) {
                selected = selectedChoice;
                showAnswer = true;
              } else if (answerStatus && isRevisionModeActive(EXAM_NAMES.SOA_FM)) {
                if (rightAnswer === 1) {
                  selected = currentQuestion[correctChoiceKey];
                  showAnswer = true;
                } else if (!rightAnswer) {
                  const choices = Object.keys(currentQuestion).filter(
                    (key) => key.startsWith('choice') && key !== correctChoiceKey,
                  );
                  selected = choices.length > 0 ? choices[0] : '';
                  showAnswer = true;
                }
              }
              const isCorrect = selected === currentQuestion[correctChoiceKey];
              if (selected && isRevisionModeActive(EXAM_NAMES.SOA_FM)) {
                clearInterval(this.timer);
                this.setState({
                  timer_stop: true,
                  timer_tag: 'Start',
                  timerstopbtn: 'pause_btn icon-control-play',
                  count: timeDone || this.state.count,
                  selectedChoice: selected,
                  clicked: true,
                  showAnswer,
                  stopTimer: true,
                  setAnswer: true,
                  ...this.getChoices(selected, isCorrect, correctChoiceKey),
                  result_block: 'card show_block',
                  text_color: isCorrect ? 'card-header text_success' : 'card-header text_failure',
                  result: isCorrect ? 'CORRECT' : 'INCORRECT',
                });
              } else {
                clearInterval(this.timer);
                this.setState({
                  timer_stop: false,
                  timer_tag: 'Stop',
                  timerstopbtn: 'pause_btn icon-control-pause',
                  count: 0,
                  selectedChoice: '',
                  clicked: false,
                  showAnswer: false,
                  stopTimer: false,
                  setAnswer: false,
                  result_block: 'card hide_block',
                });
                this.timer = setInterval(this._tick.bind(this), 1000);
              }
              
            }
            if (i === resp.questions.length - 1) {
              this.setState({ display_loader: 'hide_block' });
            }
          }
          this.setState({ questions: quesRes });
          this.setState({ offset: offsetRes });
          this.setState({ question_length: resp.questions.length });

          // Update navigation states based on initial offset
          if (offsetRes === 0) {
            this.setState({ previ_block: 'hide_block' });
          } else {
            this.setState({ previ_block: '' });
          }

          if (offsetRes === parseInt(resp.questions.length) - 1) {
            this.setState({ next_block: 'hide_block' });
          } else {
            this.setState({ next_block: '' });
          }

          const favParams = {
            token: this.state.token,
            question_id: quesRes.id,
            idname: this.state.idname,
          };
          FD.callAPI(
            `${App_data.backend_api}/soa_fm_question_bank/getFavQuestions`,
            favParams,
          ).then((response) => {
            if (response.success) {
              this.setState({
                save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
                bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
                bookmarkColor: 'rgb(54, 141, 84)',
                save_text: `${language.LC().Question_Saved}`,
                isFlashCardHidden: false,
              });
            } else {
              this.setState({ isFlashCardHidden: true });
            }
          });
          const ratingParams = {
            idname: storageSession['idname'],
            token: storageSession['token'],
            question_id: quesRes.id,
          };
          FD.callAPI(`${App_data.backend_api}/soa_fm_question_bank/getRatting`, ratingParams).then(
            (response) => {
              if (response.success) {
                this.setState({ rated: true });
                response.ratting.map((items) => {
                  this.setState({ rating: items.ratting });
                  this.setState({ ratting_text: `${language.LC().RATED}` });
                });
              }
            },
          );
          const flashParams = {
            idname: storageSession['idname'],
            token: storageSession['token'],
            question_id: quesRes.id,
          };
          FD.callAPI(
            `${App_data.backend_api}/soa_fm_question_bank/getFlashCards`,
            flashParams,
          ).then((response) => {
            if (response.success) {
              this.setState({ ValidToken: true });
              if (response.flash_cards.length > 0) {
                this.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
                const flashCards = response.flash_cards.map((items, index) => (
                  <li key={index}>
                    <div className=''>
                      <ul className='icon_list'>
                        <li>
                          <a className='pointer_class' onClick={this._editFlash.bind(this, items)}>
                            <i className='fa fa-pencil' />
                          </a>
                        </li>
                        <li>
                          <a
                            className='pointer_class'
                            onClick={this._deleteFlash.bind(this, items)}
                          >
                            <i className='fa fa-close' />
                          </a>
                        </li>
                      </ul>
                      <div className={this.state.flash_class}>
                        <h4 />
                        <p>{items.flash_card}</p>
                      </div>
                    </div>
                  </li>
                ));
                this.setState({ flash_data: flashCards });
              } else {
                this.setState({
                  flash_form: 'col-sm-12 col-md-12 display_block',
                });
                const flashCards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
                this.setState({ flash_data: flashCards });
              }
            } else {
              this.setState({
                ValidToken: false,
                flash_data: <p>{language.LC().NO_FLASHCARD_FOUND}</p>,
                flash_form: 'col-sm-12 col-md-12 display_block',
              });
            }
          });
          this.setState({ records: '' });
        } else {
          this.setState({
            ValidToken: false,
            alert_status: true,
            MessageTitle: `${language.LC().ALERT}`,
            MessageContent: `${language.LC().ERROR}`,
            records: `${language.LC().Result_not_found}`,
          });
        }
        return resp;
      },
    );

    await FD.callAPI(`${App_data.backend_api}/soa_fm_question_bank/getChapterbyID`, data).then(
      (resp) => {
        if (resp.success) {
          this.setState({ chapter_name: resp.chapters[0].chapter_name });
        }
      },
    );
    this.setState({ display_loader: 'hide_block' });
  }

  /*on url change run this function*/
  componentWillReceiveProps(nextProps) {
    if (nextProps.params.id != this.props.params.id) {
      this._changeContent(
        nextProps.params.id,
        nextProps.params.notesid,
        this.state.token,
        this.state.idname,
        nextProps.params.offset,
      );
      this.setState({ display_loader: 'show_block' });
    }
  }

  /*on url change run this function*/
  _changeContent(qui_id, chapter_id, token_id, idname, offset_val, subscription) {
    this.setState({ display_loader: 'show_block' });
    var data = {
      token: token_id,
      idname: idname,
      reading_id: this.state.page,
      chapter_id: chapter_id,
      offset: offset_val,
      subscriptionstatus: this.state.subscriptionstatus,
    };
    FD.callAPI(App_data.backend_api + '/soa_fm_question_bank/getQuestions_allcr', data).then(
      (resp) => {
        if (resp.success && resp.questions && resp.questions.length > 0) {
          this.setState({
            ValidToken: true,
            alert_status: false,
            MessageTitle: '',
            MessageContent: '',
            all_questions_state: resp.questions,
          });
          let ques_res = [];
          let offset_res = '';
          for (var i = 0; i < resp.questions.length; i++) {
            if (resp.questions[i].id == this.props.params.id) {
              ques_res = resp.questions[i];
              offset_res = i;
              const currentQuestion = resp.questions[i];

              // Get answer state for navigation (match SOA-P logic exactly)
              let selected = '';
              let showAnswer = false;
              const selectedChoice = currentQuestion['soa_fm_question_stats.selected_choice'] || '';
              const rightAnswer = currentQuestion['soa_fm_question_stats.right_answer'];
              const answerStatus = currentQuestion['soa_fm_question_stats.id'] || '';
              const timeDone = currentQuestion['soa_fm_question_stats.time_done'] || '';
              const correctChoiceKey = 'right_choice';
              if (selectedChoice && isRevisionModeActive(EXAM_NAMES.SOA_FM)) {
                selected = selectedChoice;
                showAnswer = true;
              } else if (answerStatus && isRevisionModeActive(EXAM_NAMES.SOA_FM)) {
                if (rightAnswer === 1) {
                  selected = currentQuestion[correctChoiceKey];
                  showAnswer = true;
                } else if (!rightAnswer) {
                  const choices = Object.keys(currentQuestion).filter(
                    (key) => key.startsWith('choice') && key !== correctChoiceKey,
                  );
                  selected = choices.length > 0 ? choices[0] : '';
                  showAnswer = true;
                }
              }
              const isCorrect = selected === currentQuestion[correctChoiceKey];

              // Handle timer based on selected choice
              if (selected && isRevisionModeActive(EXAM_NAMES.SOA_FM)) {
                // Ensure timer is stopped
                clearInterval(this.timer);
                this.setState({
                  timer_stop: true,
                  timer_tag: 'Start',
                  timerstopbtn: 'pause_btn icon-control-play',
                  count: timeDone || this.state.count,
                  selectedChoice: selected,
                  clicked: true,
                  showAnswer,
                  stopTimer: true,
                  setAnswer: true,
                  ...this.getChoices(selected, isCorrect, correctChoiceKey),
                  result_block: 'card show_block',
                  text_color: isCorrect ? 'card-header text_success' : 'card-header text_failure',
                  result: isCorrect ? 'CORRECT' : 'INCORRECT',
                });
              } else {
                // Start timer if no choice is selected
                clearInterval(this.timer);
                this.setState({
                  timer_stop: false,
                  timer_tag: 'Stop',
                  timerstopbtn: 'pause_btn icon-control-pause',
                  count: 0,
                  selectedChoice: '',
                  clicked: false,
                  showAnswer: false,
                  stopTimer: false,
                  setAnswer: false,
                  result_block: 'card hide_block',
                });
                this.timer = setInterval(this._tick.bind(this), 1000);
              }

              this.setState({
                questions: currentQuestion,
                selectedChoice: selected,
                clicked: !!selected,
                showAnswer: !!selected,
                stopTimer: !!selected,
                setAnswer: !!selected,
                ...this.getChoices(selected, isCorrect, correctChoiceKey),
                result_block: selected ? 'card show_block' : 'card hide_block',
                text_color: isCorrect ? 'card-header text_success' : 'card-header text_failure',
                result: isCorrect ? 'CORRECT' : 'INCORRECT',
              });
            }
            if (i == resp.questions.length - 1) {
              this.setState({ display_loader: 'hide_block' });
            }
          }
          this.setState({ questions: ques_res });
          this.setState({ offset: offset_res });
          this.setState({ question_length: resp.questions.length });

          // Update navigation states based on initial offset
          if (offset_res === 0) {
            this.setState({ previ_block: 'hide_block' });
          } else {
            this.setState({ previ_block: '' });
          }

          if (offset_res === parseInt(resp.questions.length) - 1) {
            this.setState({ next_block: 'hide_block' });
          } else {
            this.setState({ next_block: '' });
          }

          var params = {
            token: this.state.token,
            question_id: ques_res.id,
            idname: this.state.idname,
          };
          FD.callAPI(App_data.backend_api + '/soa_fm_question_bank/getFavQuestions', params).then(
            (response) => {
              if (response.success) {
                this.setState({
                  save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
                  bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
                  bookmarkColor: 'rgb(54, 141, 84)',
                  save_text: `${language.LC().Question_Saved}`,
                  isFlashCardHidden: false,
                });
              } else {
                this.setState({
                  save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
                  bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
                  bookmarkColor: '',
                  save_text: `${language.LC().SAVE_QUESTION}`,
                  isFlashCardHidden: true,
                });
              }
            },
          );
          var params = {
            idname: storage_session['idname'],
            token: storage_session['token'],
            question_id: ques_res.id,
          };
          //Api to get ratting
          FD.callAPI(App_data.backend_api + '/soa_fm_question_bank/getRatting', params).then(
            (response) => {
              if (response.success) {
                this.setState({ rated: true });
                response.ratting.map((items) => {
                  this.setState({ rating: items.ratting });
                  this.setState({ ratting_text: `${language.LC().RATED}` });
                });
              }
            },
          );

          var params = {
            idname: storage_session['idname'],
            token: storage_session['token'],
            question_id: ques_res.id,
          };
          //Api to fetch flashcard by question id
          FD.callAPI(App_data.backend_api + '/soa_fm_question_bank/getFlashCards', params).then(
            (response) => {
              if (response.success) {
                this.setState({ ValidToken: true });
                if (response.flash_cards.length > 0) {
                  this.setState({ flash_form: 'col-sm-12 col-md-12 hide_block' });
                  var flash_cards = response.flash_cards.map((items, index) => (
                    //alert(items.id)
                    <li key={index}>
                      <div className=''>
                        <ul className='icon_list'>
                          <li>
                            <a
                              className='pointer_class'
                              onClick={this._editFlash.bind(this, items)}
                            >
                              <i className='fa fa-pencil' />
                            </a>
                          </li>
                          <li>
                            <a
                              className='pointer_class'
                              onClick={this._deleteFlash.bind(this, items)}
                            >
                              <i className='fa fa-close' />
                            </a>
                          </li>
                        </ul>
                        <div className={this.state.flash_class}>
                          <h4 />
                          <p>{items.flash_card}</p>
                        </div>
                      </div>
                    </li>
                  ));
                } else {
                  this.setState({
                    flash_form: 'col-sm-12 col-md-12 display_block',
                  });
                  var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
                }
                this.setState({ flash_data: flash_cards });
              } else {
                var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
                this.setState({
                  ValidToken: false,
                  flash_data: flash_cards,
                  flash_form: 'col-sm-12 col-md-12 display_block',
                });
              }
              return response;
            },
          );

          this.setState({ records: '' });
        } else {
          this.setState({
            ValidToken: false,
            alert_status: true,
            MessageTitle: `${language.LC().ALERT}`,
            MessageContent: `${language.LC().ERROR}`,
            records: `${language.LC().Result_not_found}`,
          });
        }
        return resp;
      },
    );
    this.setState({ display_loader: 'hide_block' });
  }

  /*Function to start or stop timer*/
  _timer_funct = () => {
    // Prevent timer from starting if already answered
    if (this.state.clicked || this.state.selectedChoice) {
      // Optionally, show a message or just do nothing
      return;
    }
    const newTimerStopState = !this.state.timer_stop;
    this.setState({
      timer_stop: newTimerStopState,
      timerstopbtn: newTimerStopState
        ? 'pause_btn icon-control-play'
        : 'pause_btn icon-control-pause',
    });
    localStorage.setItem('timer_stop', JSON.stringify(newTimerStopState));
    if (newTimerStopState) {
      if (this.timer) {
        clearInterval(this.timer);
      }
    } else {
      this.timer = setInterval(this._tick.bind(this), 1000);
    }
  };

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  // Add this helper function inside the class
  getChoices(selected, isCorrect, correct) {
    const choices = ['choice_a', 'choice_b', 'choice_c', 'choice_d', 'choice_e'];
    const state = {};
    choices.forEach((choice) => {
      if (selected === choice) {
        state[choice] = isCorrect ? 'answer_box success' : 'answer_box failure';
      } else if (correct === choice && selected) {
        state[choice] = 'answer_box success';
      } else {
        state[choice] = 'answer_box';
      }
    });
    return state;
  }

  render() {
    const { reportLoading, questions, isFlashCardHidden } = this.state;

    let data = '';
    let forumData = '';
    let count_temp_var = this.state.count;
    let display_time = '';
    if (count_temp_var < 60) {
      display_time = count_temp_var + 'sec';
    } else {
      var temp_min = Math.trunc(count_temp_var / 60);
      var temp_sec = Math.trunc(count_temp_var % 60);
      display_time = temp_min + 'min ' + temp_sec + 'sec';
    }
    var retun_all_question = JSON.stringify(this.state.questions);
    var all_questions = JSON.parse(retun_all_question);
    if (all_questions != '') {
      data = (
        <div className='col-sm-12'>
          <div className='card margin_bottom_40'>
            <div className='card-header'>
              <img
                src={App_data.frontend_url + '/img/question_bank/question_icon_blue.svg'}
                className='margin_right_20'
                width='30'
                alt=''
              />
              {renderHTMLContent(all_questions.name, 'span', '', { contentEditable: 'false' })} (
              {language.LC().Q} {all_questions.id})
              <div className='float-right text-right'>
                <i
                  className={'fa fa-angle-left ques_arrow pointer_class ' + this.state.previ_block}
                  onClick={this.getPrevious}
                />
                <i
                  className={'fa fa-angle-right ques_arrow pointer_class ' + this.state.next_block}
                  onClick={this.getNext}
                />
              </div>
            </div>
            <div className='card-block'>
              <div className='row'>
                <div className='col-sm-9'>
                  <div className='row'>
                    <div className='col-sm-12'>
                      <ViewQuestion
                        {...all_questions}
                        {...this.props}
                        setAnswer={this.getAnswer}
                        showAnswer={this.state.clicked}
                        correctChoice={`${all_questions.right_choice}`}
                        selectedChoice={this.state.selectedChoice}
                        onValidate={() => this.getResult(all_questions)}
                        disabled={!this.state.selectedChoice || this.state.clicked}
                      >
                        <Col md={12} className='mt-2'>
                          <Row className='align-items-center'>
                            <div className='d-flex align-items-center'>
                              <ValidateSaveReportIcon
                                isQue={true}
                                _getResult={this.getResult}
                                clicked={this.state.clicked}
                                _saveQuestion={this._saveQuestion}
                                _displayReportForm={this._displayReportForm}
                                all_questions={all_questions}
                                save_text={this.state.save_text}
                                bookmarkCSS={this.state.bookmarkCSS}
                                bookmarkColor={this.state.bookmarkColor}
                                disabled={!this.state.selectedChoice || this.state.clicked}
                              />
                            </div>
                            <div className='col-lg-6 col-md-12 mt-md-1 mt-lg-0 text-lg-right'>
                              <div className='star_rating_wrap'>
                                <span className=' margin_bottom_0 margin_right_10'>
                                  {this.state.ratting_text}
                                </span>
                                <StarRatings
                                  rating={this.state.rating}
                                  starRatedColor='rgb(255, 180, 0)'
                                  starEmptyColor='rgb(51, 51, 51)'
                                  starDimension='20px'
                                  starHoverColor='rgb(255, 180, 0)'
                                  starSpacing='2px'
                                  changeRating={this.onStarClick.bind(this, all_questions)}
                                  numberOfStars={5}
                                  name='rate1'
                                />
                              </div>
                            </div>
                          </Row>
                        </Col>
                      </ViewQuestion>
                    </div>
                  </div>
                </div>
                <div className='col-sm-3'>
                  <div className='timer_outer'>
                    <i className='fa fa-clock-o' />
                    <span className='timer_box'>{display_time}</span>
                  </div>

                  <button
                    type='button'
                    className={this.state.timerstopbtn}
                    onClick={this._timer_funct}
                  >
                    {/*this.state.timer_tag*/}
                  </button>
                  {this.state.subscriptionstatus === 'free' ? (
                    <a
                      onClick={this._getSubscribe}
                      className='box_question_color text-center cursor_pointer'
                    >
                      <p className='margin_bottom_0'>
                        {' '}
                        {language.LC().SUBSCRIBE_FOR_1500_PRACTICE_QUESTIONS}{' '}
                      </p>
                    </a>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className={`${this.state.result_block} font-lusitana font-16px`}>
            <div className={this.state.text_color}>{this.state.result}</div>
            <div className='card-block'>
              {renderHTMLContent(all_questions.answer, 'p', 'view_questionhtml', {
                contentEditable: 'false',
              })}
            </div>
          </div>

          <div className={this.state.report_block}>
            <div className='card-header'>
              {language.LC().REPORT}
              {/* <TooltipItem
                key="1"
                id="1"
                content={this.state.tooltips[1].placement}
                place_tip={this.state.tooltips[1].text_align}
              /> */}
            </div>
            {!this.state.successAlert ? (
              <div className='card-block'>
                <div className='row'>
                  <div className='col-sm-12'>
                    <label className='form-control-label' htmlFor='textarea-input'>
                      <strong> {language.LC().COMMENT}</strong>
                    </label>
                  </div>
                  <div className='col-sm-12 margin_bottom_10'>
                    <textarea
                      id='comment'
                      name='comment'
                      rows='6'
                      className='form-control'
                      placeholder='Content..'
                    />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-sm-12'>
                    <button
                      type='button'
                      className='btn btn-primary active pointer_class report-btn'
                      disabled={reportLoading}
                      onClick={this._reportQuestion.bind(this, all_questions)}
                    >
                      {' '}
                      {reportLoading ? language.LC().PLEASE_WAIT : language.LC().REPORT}
                    </button>
                    <button
                      type='button'
                      className='btn btn-danger active pointer_class margin_left_10'
                      onClick={this._hideReportForm.bind(this, all_questions)}
                    >
                      {' '}
                      {language.LC().CANCEL}
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className='card-block'>
                <div className='row'>
                  <div className='col-sm-12 report-Success-card'>
                    <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                    <label className='form-control-label' htmlFor='textarea-input'>
                      <strong> {language.LC().REPORT_SEND_SUCCESS_MESSAGE}</strong>
                    </label>
                    <button
                      type='button'
                      className='btn btn-primary active pointer_class  min-vw-120'
                      onClick={this.onClose}
                    >
                      {' '}
                      {language.LC().CLOSE}
                    </button>
                  </div>
                </div>
              </div>
            )}{' '}
          </div>

          <div className='row'></div>
        </div>
      );
    } else {
      /*data = <div className="col-sm-12 col-md-12">
          <div className="no_data_bar card">No Records Found</div></div>;*/
    }

    return (
      <div>
        <div className='animated fadeIn'>
          {/* <div className="row">
            <div className="col-sm-8 margin_bottom_20"> */}

          <div className='margin_bottom_20 d-flex justify-content-between'>
            <h1 className='section_head'>{language.LC().QUESTION_BANK}</h1>
            {/* </div>

            <div className="col-sm-4 margin_bottom_20 text-sm-right"> */}
            <button
              type='button'
              className='btn btn-primary pointer_class'
              onClick={this._getReadings}
            >
              {language.LC().CHANGE_QUESTIONS}
            </button>
            {/* </div> */}
          </div>
          <div className='row'>{data}</div>
          <FlashCard
            item={questions}
            type='question'
            isFlashCardHidden={isFlashCardHidden}
            ref={this.setChildRef}
            exam='soa_fm'
          />
        </div>
        <div className={'loader_box ' + this.state.display_loader}>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      </div>
    );
  }
}

/*
-----------------------------------
  Class component for tooltip
-----------------------------------
*/
class TooltipItem extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      tooltipOpen: false,
    };
  }

  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  }

  render() {
    return (
      <span>
        <img
          src={App_data.frontend_url + '/img/dashboard/info_icon.svg'}
          id={'Tooltip-' + this.props.id}
          width='18'
          alt=''
          style={{ marginLeft: '4px' }}
        />
        {/*<i className="fa fa-info-circle"  id={'Tooltip-' + this.props.id} ></i>*/}

        <Tooltip
          placement={this.props.place_tip}
          isOpen={this.state.tooltipOpen}
          target={'Tooltip-' + this.props.id}
          toggle={this.toggle}
        >
          <p className='tooltip_text'>{this.props.content}</p>
        </Tooltip>
      </span>
    );
  }
}

export default SOA_FM_Beginchapters;



// WEBPACK FOOTER //
// ./src/views/SOA/FinancialMathematics/Beginchapters/Beginchapters.js